/**
 * Location Service
 * Location and serviceability checking service
 */
import { locationClient } from "./client";

export const locationService = {
  /**
   * Check service availability at location
   * @param {Object} locationData - Location coordinates and details
   */
  checkServiceability(locationData) {
    return locationClient.post("/check-serviceability", locationData);
  },

  /**
   * Get location details by coordinates
   * @param {number} lat - Latitude
   * @param {number} lng - Longitude
   */
  getLocationByCoordinates(lat, lng) {
    return locationClient.get(`/location?lat=${lat}&lng=${lng}`);
  },

  /**
   * Search locations by query
   * @param {string} query - Search query
   */
  searchLocations(query) {
    return locationClient.get(`/search?q=${encodeURIComponent(query)}`);
  },

  /**
   * Get coverage areas
   */
  getCoverageAreas() {
    return locationClient.get("/coverage-areas");
  },

  /**
   * Validate address
   * @param {Object} addressData - Address details
   */
  validateAddress(addressData) {
    return locationClient.post("/validate-address", addressData);
  },
};

export default locationService;
